import { JLPActionTypes } from '../../../../../actions/dashboards/JLP'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'

export interface DwellTimeSkuPayload {
  types: {
    [sku: string]: number;
  }
}

interface DwellTimeSkuState {
  values: number[];
  labels: string[];
  total: number;
  perc: null;
  name: string;
}

/**
 * Ark Dwell Time per Sku reducer
 */
const JLPDwellTimeSku = buildAsyncStatReducer<DwellTimeSkuPayload, DwellTimeSkuState>({
  key: Metrics.JLP_DWELL_TIME_SKU,
  types: JLPActionTypes.DASHBOARD_JLP_DWELL_TIME_SKU,
  transform: (state, { payload }): DwellTimeSkuState => {
    const { types: skusMap } = payload || {}
    const skusList: string[] = Object.keys(skusMap || {})

    const sortedList = skusList.sort(
      (a: string, b:string): number => skusMap[b] - skusMap[a],
    )

    return {
      values: sortedList.map(store => skusMap[store]),
      labels: sortedList,
      total: skusList.length,
      perc: null,
      name: 'dashboard-count-seconds',
    }
  },
})

export default JLPDwellTimeSku
